const tabs = [
  {id: 'preview', labelKey: 'client.matters.matter_page.docuforms_tab.label_preview', icon: 'icon-Eye-open', cmp: 'DocuformPreview'},
  {id: 'details', labelKey: 'client.matters.matter_page.docuforms_tab.label_details', icon: 'icon-Info', cmp: 'DocuformDetails'},
];

const actions = {
  download: { labelKey: 'client.matters.matter_page.docuforms_tab.download', icon: 'icon-conversation' },
  reupload: { labelKey: 'file.missing_file_error.reupload', icon: 'icon-conversation' },
  sendRequest: { labelKey: 'client.matters.matter_page.docuforms_tab.request_file', icon: 'icon-conversation' },
  print: { labelKey: 'client.matters.matter_page.docuforms_tab.print', icon: 'icon-note' },
  viewConversation: { labelKey: 'client.matters.matter_page.docuforms_tab.view', icon: 'icon-document' },
  share: { labelKey: 'client.matters.matter_page.docuforms_tab.share', icon: 'icon-document' },
  delete: { labelKey: 'client.matters.matter_page.docuforms_tab.delete', icon: 'icon-main_info' },
  viewSignature: { labelKey: 'client.matters.matter_page.docuforms_tab.view_signature', primary: true }
};

const statuses = {
  Internal: {
    icon: 'icon-Lock2',
    label: 'document.status.internal',
    mobileLabel: 'document.short_status.internal',
    color: '#72889C'
  },
  Reviewed: {
    icon: 'icon-Share',
    label: 'document.status.reviewed',
    mobileLabel: 'document.short_status.reviewed',
    color: '#212121'
  },
  PendingApproval: {
    icon: 'icon-Pending',
    label: 'document.status.pending_approval',
    mobileLabel: 'document.short_status.pending_approval',
    color: '#f26950'
  },
  PendingReview: {
    icon: 'icon-Pending',
    label: 'document.status.pending_review',
    mobileLabel: 'document.short_status.pending_review',
    color: '#f26950'
  },
  Submitted: {
    icon: 'icon-Completed',
    label: 'document.status.submitted',
    mobileLabel: 'document.short_status.submitted',
    color: '#54D28C'
  },
  Approved: {
    icon: 'icon-Completed',
    label: 'document.status.approved',
    mobileLabel: 'document.short_status.approved',
    color: '#54D28C'
  },
  Rejected: {
    icon: 'icon-Close',
    label: 'document.status.rejected',
    mobileLabel: 'document.short_status.rejected',
    color: '#dd2c00'
  }
}

const formats = {
  DOCUMENT: ['doc', 'docx'],
  IMAGE: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'],
  PDF: ['pdf'],
  SPREADSHEET: ['csv', 'xls', 'xlsx'],
  SLIDESHOW: ['ppt', 'pptx'],
  ARCHIVE: ['zip', 'rar'],
  AUDIO: ['mp3', 'wav'],
  VIDEO: ['avi', 'mp4', 'mkv', 'mov'],
}

export {
  tabs,
  actions,
  statuses,
  formats
}
